export { ModalBackdropComponent, ModalBackdropOptions } from './modalBackdrop.component';
export { ModalOptions, MDBModalRef } from './modal.options';
export { ModalDirective } from './modal.directive';
export { ModalModule } from './modal.module';
export { MDBModalService } from './modal.service';
export { ModalContainerComponent } from './modalContainer.component';



// WEBPACK FOOTER //
// ./src/app/typescripts/free/modals/index.ts